// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('magnific-popup/dist/jquery.magnific-popup.min');
require('select2/dist/js/select2.full.min');
require('@accessible360/accessible-slick/slick/slick.min');

//Load Modules
require('./modules/accordion');
require('./modules/animatein');
require('./modules/animationPause');
require('./modules/bannerVideo');
require('./modules/filters');
require('./modules/formInputs');
require('./modules/gravityForms'); // only include if using WordPress Gravity plugin
require('./modules/videoButtonReplacer');
require('./modules/videoPopup');
require('./modules/videoPlay');
require('./modules/menu');
require('./modules/modal');
require('./modules/reviews');
// require('./modules/scrollTo');
require('./modules/searchToggle');
require('./modules/shareSocial');
require('./modules/sideMenu');
require('./modules/slider');
require('./modules/statistics');
require('./modules/tabs');
require('./modules/alert');
require('./modules/handlebars');
